import { Form, Input } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";

export const HiddenValueField: FieldMethod = ({ field, rules }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules} hidden>
            <Input type="hidden" />
        </Form.Item>
    );
};
